<div class="dropdown" ngbDropdown placement="bottom">
  <button class="btn btn-transparent btn-sm" aria-label="Filter Column" ngbDropdownToggle>
    <i class="fas fa-filter"></i>
  </button>

  <!-- The (click) only stops propagation, as in report-config. -->
  <div class="dropdown-menu" ngbDropdownMenu (click)="stopBubble($event)">
    @for (filter of filters(); track filter) {
      <label name="configRow" class="config-row">
        <input type="checkbox" (click)="applyFilter(filter)" [attr.checked]="isSelected(filter)" />
        <span class="filter-name">{{ filter }}</span>
      </label>
    }
  </div>
</div>
